import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Row, Col, Tab, Form, Nav, Dropdown, Button, ModalFooter } from 'react-bootstrap';
import filter from '../../assets/img/people/filter.svg'
import search from '../../assets/img/icons/search.svg'
import more from '../../assets/img/icons/more.svg'
import attach from '../../assets/img/icons/attach.svg'
import msglogo from '../../assets/img/icons/msglogo.png'
import star from '../../assets/img/icons/star.svg'
import staractive from '../../assets/img/icons/staractive.svg'
import axios from "axios";
import socketIOClient from "socket.io-client";
import back from '../../assets/img/icons/back.svg'
import { googleTranslate } from "../../config/googleTranslate";
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import ImageZoom from 'react-medium-image-zoom';
import { Trans } from "react-i18next";   
import "../../config/i18n";
import { withTranslation } from "react-i18next";

const cryptLib = require("@skavinvarnan/cryptlib");
const encryptKey = "crypt@123";

var typingTrack = 0;
var timerId = undefined;

class Messgae extends Component {

    constructor(props) {
        super(props);
        this.messagesEndRef = React.createRef();
        this.fileInputRef = React.createRef();
        this.msgSearch = this.msgSearch.bind(this);
        this.msgFilter = this.msgFilter.bind(this);
        this.onBlock = this.onBlock.bind(this);
        this.onUnfriend = this.onUnfriend.bind(this);
        this.onClearchat = this.onClearchat.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.translateChat = this.translateChat.bind(this);
        this.changeHandler = this.changeHandler.bind(this);
        this.state = {
            endpoint: "https://kabadate.com:8086",
            api_url: localStorage.getItem('api_url'),
            messagers: [], limit: 8, chats: [], appof_day: [], langKey: 'en',
            starClicked: {
                first: false,
                second: false,
                third: false,
                fourth: false,
                blocked_by_me: "",
                block_info: "",
                delete_info: "",
            },
            loading: 'd-none',
            transtext: '',
            languageCodes: [],
            appof_image: [],
            language: "",
            inputValue: "",
            appofmodal: false,
        };

        const socket = socketIOClient(this.state.endpoint);
        socket.on("broad", (data) => {
            this.setState({ loading: "d-none" });
            console.log("Broad data: ", data); 
            if (data.receiver_id === JSON.parse(localStorage.getItem('session_userid'))) {
                this.addMsg(data);
            }
        });

        socket.on("receivetyping", (data) => {
            if (data.message === "type") {
                if (data.receiver_id === JSON.parse(localStorage.getItem('session_userid'))) {
                    this.setState({ loading: "loadingTxts" });
                }
            } else {
                this.setState({ loading: "d-none" });
            }
        });
        
        socket.on("receiveuntyping", (data) => {
            if (data.receiver_id === JSON.parse(localStorage.getItem('session_userid'))) {
                this.setState({ loading: "d-none" });
            }
        });
    }

    changeHandler = (language) => {
        localStorage.setItem("chatTransLang", JSON.stringify(language));
        this.setState({
            language: language,
        });
    };

    translateChat(question, language, index) {
        let temparray = [...this.state.chats];
        if (question && language) {
            googleTranslate.translate(question, language, (err, translation) => {
            if (translation.translatedText) {
                temparray[index].message = translation.translatedText;
                this.setState({
                    chats: temparray,
                });
            }
            });
        }
    }

    scrollToBottom = () => {
        this.messagesEndRef.scrollIntoView();
    }

    scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    componentDidMount() {
        if (this.props.i18n.language === 'ar' || this.props.i18n.language === 'he') {
            document.body.dir = 'rtl';
            document.body.classList.add('rtl');
            document.body.classList.remove('ltr')
        } else {
            document.body.dir = 'ltr';
            document.body.classList.remove('rtl');
            document.body.classList.add('ltr');
        }
        
        const apiUrl = localStorage.getItem('api_url');
        var app = new FormData();
        app.set('language', this.state.langKey);
        axios({
            method: 'post',
            url: apiUrl + 'appoftheday',
            data: app,
            config: { headers: { 'Content-Type': 'multipart/form-data' } }
        }).then(res => {
            const appof_day = res.data.result;
            this.setState({
                appof_day,
                appof_image: appof_day.images,
            });

            var message = new FormData();
            message.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
            message.set('search_key', '');
            message.set('sort', '');
            message.set('timestamp', '');
            message.set('limit', this.state.limit);
            message.set('language', this.state.langKey);
            axios({
                method: 'post',
                url: apiUrl + 'webgetchat',
                data: message,
                config: { headers: { 'Content-Type': 'multipart/form-data' } }
            }).then(res => {
                const messagers = res.data.matches;
                const tmp_limit = this.state.limit;
                if (res.data.status !== 'false') {
                    this.messageClick(messagers[0].user_id, messagers[0].chat_id);
                    if (this.state.messagers.length > 0) {
                        this.setState({
                            chat_id: this.state.messagers[0].chat_id
                        }, () => {
                            this.messageClick(this.state.messagers[0].user_id, this.state.messagers[0].chat_id);
                        });
                    }
                    const totalchats = res.data.total;
                    this.setState({
                        messagers: messagers,
                        limit: this.state.limit + 8
                    });
                    if (tmp_limit < totalchats) {
                        this.setState({ loadmore: 'loadMor btn-common' });
                    }
                }
            });
        });

        googleTranslate.getSupportedLanguages("en", function (err, languageCodes) {
            getLanguageCodes(languageCodes); // use a callback function to setState
        });
        const getLanguageCodes = (languageCodes) => {
            this.setState({ languageCodes });
        };
    }

    loadMore() {
        var message = new FormData();
        message.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
        var searchtxt = document.getElementById('search-txt').value;
        if (searchtxt) {
            message.set('search_key', searchtxt);
        } else {
            message.set('search_key', '');
        }
        message.set('sort', '');
        message.set('timestamp', '');
        message.set('limit', this.state.limit);
        message.set('language', this.state.langKey);
        axios({
            method: 'post',
            url: this.state.api_url + 'webgetchat',
            data: message,
            config: { headers: { 'Content-Type': 'multipart/form-data' } }
        }).then(res => {
            const messagers = res.data.matches;
            const tmp_limit = this.state.limit;
            if (res.data.status !== 'false') {
                const totalchats = res.data.total;
                this.setState({
                    messagers: messagers,
                    limit: this.state.limit + 8
                });
                if (tmp_limit < totalchats) {
                    this.setState({ loadmore: 'loadMor btn-common' });
                } else {
                    this.setState({ loadmore: 'none' });
                }
            }
        });
    }

    handleStarClick = (index) => {
        var message = new FormData();
        message.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
        message.set('favorite_user_id', index);
        message.set('language', this.state.langKey);
        axios({
            method: 'post',
            url: this.state.api_url + 'webfavorite',
            data: message,
            config: { headers: { 'Content-Type': 'multipart/form-data' } }
        }).then(res => {
            var message = new FormData();
            message.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
            message.set('search_key', '');
            if (this.state.cur_sort) {
                message.set('sort', this.state.cur_sort);
            } else {
                message.set('sort', '');
            }
            message.set('timestamp', '');
            message.set('language', this.state.langKey);
            axios({
                method: 'post',
                url: this.state.api_url + 'webgetchat',
                data: message,
                config: { headers: { 'Content-Type': 'multipart/form-data' } }
            }).then(res => {
                const messagers = res.data.matches;
                if (res.data.status !== 'false') {
                    this.setState({ messagers });
                    this.setState({ 
                        filter_status: res.data.status 
                    });
                } else {
                    this.setState({ messagers });
                    this.setState({ 
                        filter_status: res.data.status 
                    });
                }
            });
        });
    }

    msgSearch(e) {
        const tmp = e.target.value;
        this.setState({ msg_search: tmp });
        if (e.target.value != null) {
            var message = new FormData();
            message.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
            message.set('search_key', e.target.value);
            message.set('sort', '');
            message.set('timestamp', '');
            message.set('language', this.state.langKey);
            axios({
                method: 'post',
                url: this.state.api_url + 'webgetchat',
                data: message,
                config: { headers: { 'Content-Type': 'multipart/form-data' } }
            }).then(res => {
                const messagers = res.data.matches;
                const tmp_limit = 8;
                if (res.data.status !== 'false') {
                    const totalchats = res.data.total;
                    if (tmp_limit < totalchats) {
                        this.setState({ loadmore: 'loadMor btn-common' });
                    } else {
                        this.setState({ loadmore: 'none' });
                    }
                    this.setState({ messagers });
                } else {
                    this.setState({ messagers });
                    this.setState({ 
                        filter_status: res.data.status 
                    });
                }
            });
        }
    }

    msgFilter = (value) => {
        var message = new FormData();
        message.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
        message.set('search_key', '');
        message.set('sort', value);
        message.set('language', this.state.langKey);
        this.setState({ cur_sort: value });
        message.set('timestamp', '');
        axios({
            method: 'post',
            url: this.state.api_url + 'webgetchat',
            data: message,
            config: { headers: { 'Content-Type': 'multipart/form-data' } }
        }).then(res => {
            const messagers = res.data.matches;
            if (res.data.status !== 'false') {
                this.setState({ messagers });
                this.setState({ 
                    filter_status: res.data.status 
                });
            } else {
                this.setState({ messagers });
                this.setState({ 
                    filter_status: res.data.status 
                });
            }
        });
    }

    messageClick(user_id, chat_id) {
        const apiUrl = localStorage.getItem('api_url');
        var message = new FormData();
        message.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
        message.set('chatuser_id', user_id);
        message.set('chat_id', chat_id);
        message.set('language', this.state.langKey);
        axios({
            method: 'post',
            url: apiUrl + 'webgetchatmessage',
            data: message,
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(res => {
            const { chats, chats_online, chats_userstatus, chats_user_id, chats_user_name, chats_user_image, chats_onlinelasttime } = res.data;
            let online;
            let delete_info;
            if(chats_userstatus === 2) {
                online = "Deleted User";
                delete_info = "This User has deleted";
            } else if(chats_userstatus === 3 || chats_userstatus === 0) {
                online = "Blocked User";
                delete_info = "This User has blocked by Admin";   
            } else {
                online = chats_userstatus === 2 ? "Deleted User" : (chats_online ? "Active Now" : chats_onlinelasttime);
                delete_info = chats_userstatus === 2 ? "This User has deleted" : "";
            }
            

            this.setState({
                chats: chats || [],
                chats_user_id,
                chats_user_name,
                chats_user_image,
                online_status: online,
                chat_id: chat_id,
                chats_userstatus: chats_userstatus,
                delete_info: delete_info
            }, () => {
                console.log('State updated with chats:', this.state.chats);
                this.scrollToBottom();
            });

        }).catch(error => {
            console.error('Error fetching chat messages:', error);
        });
        var data_block = new FormData();
        data_block.set("user_id", JSON.parse(localStorage.getItem('session_userid')));
        data_block.set("chatid", chat_id);
        data_block.set("language", this.state.langKey);
        axios({
            method: "post",
            url: this.state.api_url + "blockstatus",
            data: data_block,
            config: { headers: { "Content-Type": "multipart/form-data" } },
        }).then((res) => {
            const details = res.data;

            this.setState({
                block: details.block,
                blocked_by_me: details.blocked_by_me,
            });
            if (this.state.blocked_by_me === "true") {
                this.setState({
                    blocked_by_me: "unblock",
                    block_info: "Unblock to message"
                });
            } else {
                this.setState({
                    blocked_by_me: "block"
                });
                if (this.state.block === "true") {
                    this.setState({
                        blocked_by_me: "",
                        block_info: "This User has Blocked you"
                    });
                }
            }
        });
        const socket = socketIOClient(this.state.endpoint);
        socket.emit('join', {
            join_id: JSON.parse(localStorage.getItem('session_userid')),
        });
    }

    addMsg(data) {
        const chats = [this.state.chats];
        var months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
        var d = new Date(parseInt(data.message.chatTime) * 1000);
        var dt = d.getDate();
        var mon = months[d.getMonth()];
        var yr = d.getFullYear();
        var mydate = dt + ', ' + (mon) + ' ' + yr;
        var transLangCode = 'en';
        if (data.message.type === 'text') {
            var transtext = cryptLib.decryptCipherTextWithRandomIV(data.message.message,encryptKey);
            if(JSON.parse(localStorage.getItem('chatTransLang'))) {
                transLangCode = JSON.parse(localStorage.getItem('chatTransLang')).length===4 ? 'en' : JSON.parse(localStorage.getItem('chatTransLang'));
            }
            googleTranslate.translate(transtext,transLangCode, (err, translation) => {
                if(translation.translatedText) {
                    if(data.sender_id === JSON.parse(localStorage.getItem('session_userid'))) {
                        const recmsg = {
                            "message": transtext,
                            "sender_id": data.sender_id,
                            "receiver_id": data.receiver_id,
                            "image": "",
                            "date": mydate,
                            "type": data.message.type
                        }
                        this.setState(prevState => ({
                            chats: [...prevState.chats, recmsg]
                        }), () => {
                            this.scrollToBottom();
                        });
                    } else {
                        const recmsg = {
                            "message": translation.translatedText,
                            "sender_id": data.sender_id,
                            "receiver_id": data.receiver_id,
                            "image": "",
                            "date": mydate,
                            "type": data.message.type
                        }
                        this.setState(prevState => ({
                            chats: [...prevState.chats, recmsg]
                        }), () => {
                            this.scrollToBottom();
                        });
                    }
                } else {
                    const recmsg = {
                        "message": transtext,
                        "sender_id": data.sender_id,
                        "receiver_id": data.receiver_id,
                        "image": "",
                        "date": mydate,
                        "type": data.message.type
                    }
                    this.setState(prevState => ({
                        chats: [...prevState.chats, recmsg]
                    }), () => {
                        this.scrollToBottom();
                    });
                }
            });
        } else if (data.message.type === 'image') {
            const recmsg = {
                "message": "",
                "sender_id": data.sender_id,
                "receiver_id": data.receiver_id,
                "upload_image": data.message.upload_image,
                "date": mydate,
                "type": data.message.type
            }
            this.setState(prevState => ({
                chats: [...prevState.chats, recmsg]
            }), () => {
                this.scrollToBottom();
            });
        } else if(data.message.type === 'gif') {
            var transtext = "Gif Image";
            const recmsg = {
                "message": transtext,
                "sender_id": data.sender_id,
                "receiver_id": data.receiver_id,
                "image": "",
                "date": mydate,
                "type": data.message.type
            }
            this.setState(prevState => ({
                chats: [...prevState.chats, recmsg]
            }), () => {
                this.scrollToBottom();
            });
        } else if(data.message.type === 'audio_msg') {
            var transtext = "Audio Message";
            const recmsg = {
                "message": transtext,
                "sender_id": data.sender_id,
                "receiver_id": data.receiver_id,
                "image": "",
                "date": mydate,
                "type": data.message.type
            }
            this.setState(prevState => ({
                chats: [...prevState.chats, recmsg]
            }), () => {
                this.scrollToBottom();
            });
        }
    }

    scrollToBottom = () => {
        this.messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }

    onBlock = (chats_user_id) => {
        var clearchat = new FormData();
        clearchat.set("user_id", JSON.parse(localStorage.getItem('session_userid')));
        clearchat.set("block_user_id", chats_user_id);
        clearchat.set("language", this.state.langKey);

        axios({
            method: "post",
            url: this.state.api_url + "webblockchat",
            data: clearchat,
            config: { headers: { "Content-Type": "multipart/form-data" } },
        }).then((res) => {
            if (res.data.status !== 'false') {
                this.setState({
                    successMessage: res.data.message,
                    suc_cls: 'successMsg floatingAlerts1'
                });
            }
            setTimeout(() => {
                this.setState({
                    suc_cls: 'successMsghide'
                });
                window.location.reload();
            }, 1000);
        }).catch((error) => {
            console.error("Error when trying to block/unblock user:", error);
            this.setState({
                successMessage: "Network error or server is unavailable.",
                suc_cls: 'errorMsg'
            });
        });
    }

    onClearchat(chat_id) {
        var clearchat = new FormData();
        clearchat.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
        clearchat.set('chat_id', chat_id);
        clearchat.set('language', this.state.langKey); 
        axios({
            method: 'post',
            url: this.state.api_url + 'webclearchat',
            data: clearchat,
            config: { headers: { 'Content-Type': 'multipart/form-data' } }
        }).then(res => {
            window.location.reload();
        })

    }

    onUnfriend = (chats_user_id) => {
        var clearchat = new FormData();
        clearchat.set("user_id", JSON.parse(localStorage.getItem('session_userid')));
        clearchat.set("unfriend_user_id", chats_user_id);
        clearchat.set("language", this.state.langKey);
        axios({
            method: "post",
            url: this.state.api_url + "webunfriend",
            data: clearchat,
            config: { headers: { "Content-Type": "multipart/form-data" } },
        }).then((res) => {
            window.location.reload();
        });
    }

    handleKeyUp (e) {
        const keycode = e.keyCode;
        const { endpoint, chat_id, chats_user_id } = this.state;
        const socket = socketIOClient(endpoint);

        if(typingTrack === 0 && keycode !== 13) {
            socket.emit('typing', {
                chatid: chat_id,
                sender_id: JSON.parse(localStorage.getItem('session_userid')),
                receiver_id: chats_user_id,
                message: 'type',
            });
            typingTrack = 1;
        }

        if (typingTrack === 1) {
            clearTimeout(timerId); 
        }

        if(keycode === 13) {
            this.handleSendClick(chat_id, chats_user_id);
            return false;
        }

        if(keycode !== 13) {  
            timerId = setTimeout(function () { 
                    typingTrack = 0; 
                    socket.emit('typing', {     
                        chatid: chat_id,
                        sender_id: JSON.parse(localStorage.getItem('session_userid')),
                        receiver_id: chats_user_id,
                        message: 'untype',   
                    });
            }, 2000);            
        }
    }

    handleChange = (event) => {
        typingTrack = 0;   
        clearTimeout(timerId);
        this.setState({ inputValue: event.target.value });
    }

    handleSendClick = (chat_id, chats_user_id) => {
        typingTrack = 0;   
        clearTimeout(timerId);
        const newmsg = this.state.inputValue;
        if (newmsg.trim() !== "") {
            this.setState({
                inputValue: "",
            });
            var send_message = new FormData();
            send_message.set('sender_id', JSON.parse(localStorage.getItem('session_userid')));
            send_message.set('chat_id', chat_id);
            send_message.set('receiver_id', chats_user_id);
            send_message.set('message', newmsg);
            send_message.set('chat_time', '');
            send_message.set('upload_image', '');
            send_message.set('language', this.state.langKey);

            const curtime = Math.floor(Date.now() / 1000).toString();
            this.scrollToBottom();
            this.addMsg({
                chatid: chat_id,
                sender_id: JSON.parse(localStorage.getItem('session_userid')),
                receiver_id: chats_user_id,
                message: {
                    message: cryptLib.encryptPlainTextWithRandomIV(newmsg, encryptKey),
                    upload_image: "",
                    userName: "",
                    userImage: "",
                    chatTime: curtime,
                    type: "text",
                }
            });

            axios({
                method: 'post',
                url: this.state.api_url + 'websendmessage',
                data: send_message,
                config: { headers: { 'Content-Type': 'multipart/form-data' } }
            }).then(res => {
                if (res.data.status !== "false") {
                    this.setState({
                        inputValue: "",
                    });
                    const { endpoint } = this.state;
                    const socket = socketIOClient(endpoint);
                    socket.emit("message", {
                        chatid: chat_id,
                        sender_id: JSON.parse(localStorage.getItem('session_userid')),
                        receiver_id: chats_user_id,
                        transLanguage: 'en',
                        message: {
                            message: cryptLib.encryptPlainTextWithRandomIV(newmsg, encryptKey),
                            upload_image: "",
                            userName: "",
                            userImage: "",
                            chatTime: curtime,
                            type: "text",
                        },
                    });
                } else {
                    this.props.history.push("/message");
                }
            })
        } else {
            this.setState({
                successMessage: 'Please enter the message',
                suc_cls: 'successMsg floatingAlerts1'
            });
            setTimeout(() => {
                this.setState({
                    suc_cls: 'successMsghide'
                });
            }, 5000);
        }
    }

    handleImageClick = () => {
        if (this.fileInputRef.current) {
            this.fileInputRef.current.click();
        } else {
            console.log("File input is not mounted");
        }
    };

    handleFileChange = (event) => {
        let files = event.target.files;
        if (!files.length){
            return;
        }
        const file = files[0];
        const _validFileExtensions = [".png", ".jpg", ".jpeg", ".gif"];
        const isValidExtension = _validFileExtensions.some(ext => file.name.toLowerCase().endsWith(ext));

        if (!isValidExtension) {
            alert("Sorry, invalid file!");
            return;
        }

        this.setState({
            file: URL.createObjectURL(file)
        });

        this.createImage(file);
    };

    createImage = (file) => {
        let reader = new FileReader();
        reader.onload = (e) => {
            this.setState({ images: e.target.result });
        };
        reader.readAsDataURL(file);
        setTimeout(this.onFormSubmit, 2000); // Post submission after image prep
    };

    onFormSubmit = () => {
        if (!this.state.images) {
            this.setState({
                successMessage: 'Select an image',
                suc_cls: 'successMsg floatingAlerts1'
            });

            setTimeout(() => {
                this.setState({ suc_msg: 'errorMsghide' });
            }, 2000);
            return;
        }
        this.fileUpload(this.state.images);
    };

    fileUpload(images) {
        const { chat_id, chats_user_id } = this.state;
        if (images === null || images === '') {
            this.setState({
                successMessage: 'SSelect a image',
                suc_cls: 'successMsg floatingAlerts1'
            });
            setTimeout(() => {
                this.setState({
                    suc_msg: 'errorMsghide'
                });
            }, 2000);

        } else {
            const url = this.state.api_url + 'uploadimagechat';
            const formData = { file: this.state.images, language: this.state.langKey }
            axios.post(url, formData)
            .then(res => {
                if (res.data.status === 'true') {
                    const { endpoint } = this.state;
                    const socket = socketIOClient(endpoint);
                    const curtime = Math.floor(Date.now() / 1000).toString();
                    this.addMsg({
                        chatid: this.state.chat_id,
                        sender_id: JSON.parse(localStorage.getItem('session_userid')),
                        receiver_id: this.state.chats_user_id,
                        message: {
                            message: "",
                            upload_image: res.data.imageurl,
                            userName: "",
                            userImage: "",
                            chatTime: curtime,
                            type: "image",
                        }
                    });

                    var send_message = new FormData();
                    send_message.set('sender_id', JSON.parse(localStorage.getItem('session_userid')));
                    send_message.set('chat_id', this.state.chat_id);
                    send_message.set('receiver_id', this.state.chats_user_id);
                    send_message.set('message', '');
                    send_message.set('chat_time', '');
                    send_message.set('upload_image', res.data.image_name);
                    send_message.set('language', this.state.langKey);
                    axios.post(this.state.api_url + 'websendmessage', send_message, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    }).then(result => {
                        if (result.data.status !== 'false') {
                            socket.emit('message', {
                                chatid: chat_id,
                                sender_id: JSON.parse(localStorage.getItem('session_userid')),
                                receiver_id: chats_user_id,
                                message: {
                                    message: "",
                                    upload_image: res.data.imageurl,
                                    userName: "",
                                    userImage: "",
                                    chatTime: curtime,
                                    type: "image",
                                }
                            });
                        }
                    });
                } else {
                    this.setState({
                        successMessage: res.data.message,
                        suc_cls: 'successMsg floatingAlerts1'
                    });
                    setTimeout(() => {
                        this.setState({
                            suc_msg: 'errorMsghide'
                        });
                    }, 2000);
                }
            })
            .catch(error => {
                console.error("Error uploading image:", error);
            });
        }
    }

    handleAppofopen = () => {
        this.setState({ 
            appofmodal: true 
        });
    }

    shutModal(tabId) {
        this.setState({
            [tabId]: false
        });
    }

    handleProfileclick (chatuser_id) {
        console.log("chatuser_id: ", chatuser_id);
        this.props.history.push(`/visitordetail/${chatuser_id}`); 
    }

    render() {
        const { languageCodes } = this.state;

        const containerStyle = {
            display: this.state.filter_status === 'false' ? 'none' : 'block'
        };
        
        var transLangCode;
        if(JSON.parse(localStorage.getItem('chatTransLang'))) {
            transLangCode = JSON.parse(localStorage.getItem('chatTransLang')).length === 4 ? '0' : JSON.parse(localStorage.getItem('chatTransLang'));
        } else {
            transLangCode = '0';
        }

        const settings = {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true
        };

        const { t } = this.props;

        return (
            <div className="common_layout">
                <div className='whole_information'>
                    {this.state.successMessage && (
                        <div className={this.state.suc_cls}>
                            {this.state.successMessage}
                        </div>
                    )}
                </div>
                <div className='header_layout'>
                    <div className='header_title margin_auto'>
                        <h4><Trans i18nKey="Message">Message</Trans></h4>
                    </div>
                </div>
                <div className='mt_3'>
                    <Tab.Container id="left-tabs-example" activeKey={this.state.chat_id}>
                        <div className='messgee_displaydiv'>
                            <div className='messgee_leftdisplaydiv'>
                                <div className='messagetab_leftside'>
                                    <div className='message_search'>
                                        <div className='messageleft_first'>
                                            <img src={search} alt="img" />
                                            <Form.Control onChange={this.msgSearch} value={this.state.msg_search}
                                                placeholder={t("type a message...")}
                                            />
                                        </div>
                                        <div className='messageleft_second'>
                                            <Dropdown className='messageleft_second_dropdown'>
                                                <Dropdown.Toggle id="dropdown-basic">
                                                    <img src={filter} alt="img" />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item onClick={() => this.msgFilter("0")}>All chat</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => this.msgFilter("unread")}>Unread</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => this.msgFilter("online")}>Online</Dropdown.Item>
                                                    <Dropdown.Item onClick={() => this.msgFilter("favourite")}>Favourite</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </div>
                                    {
                                        (this.state.appof_day['app_settings'] === 'enable') 
                                        ?
                                        (<div className='message_logodiv'>
                                            <img src={msglogo} alt="img" />
                                            <div className='message_logoC' onClick={this.handleAppofopen}>
                                                <h4><Trans i18nKey="App of the day">App of the day</Trans></h4>
                                                <p><Trans i18nKey="What make a great app? Find here.">What make a great app? Find here.</Trans></p>
                                            </div>
                                        </div>)
                                        :
                                        ''
                                    }
                                    <Nav variant="pills" className="flex-column messagetableftside_list">
                                        {this.state.messagers && this.state.messagers.length > 0 ?
                                            this.state.messagers.map((messager, index) => (
                                                <Nav.Item key={index}>
                                                    <Nav.Link eventKey={messager.chat_id} className='messagetab_a' onClick={() => this.messageClick(messager.user_id, messager.chat_id)}>
                                                        <div className='messagetab_leftdiv'>
                                                            <div className='messagetab_leftsubdiv'>
                                                                <div className='messgaetab_avatar'>
                                                                    <img src={messager.user_image} alt="img" />
                                                                    <div className={messager.online === 1 && messager.block === "false"?"onlineN2":""}></div>
                                                                </div>
                                                                <div >
                                                                    <h4>{messager.user_name}</h4>
                                                                    <p>{messager.imagename === '' || !('imagename' in messager) ? messager.message : messager.imagename}</p>
                                                                </div>
                                                            </div>

                                                            <div className='messagetab_left_subdivs'>
                                                                <p>{messager.date}</p>

                                                                <div className={messager.favorite === 'true' ? "star-clicked " : "star-notclick"} onClick={() => this.handleStarClick(messager.user_id)}>
                                                                    <img src={star} alt="img" id="faviture_inactive_icon"/>
                                                                    <img src={staractive} alt="img" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Nav.Link>
                                                </Nav.Item>
                                            ))
                                            : <p><Trans i18nKey="No messages available.">No messages available.</Trans></p>
                                        }
                                    </Nav>
                                </div>
                            </div>
                            <div className='messgee_rightdisplaydiv' style={containerStyle}>
                                <Tab.Content>
                                    <Tab.Pane eventKey={this.state.chat_id} className='messagetab_rightside'>
                                        <div className=''>
                                            <div className='mesagetabRight_header'>
                                                <div className='messageRight_subH'>
                                                    <div className='mobile_messagedivs'>
                                                        <div className='mobile_messagediv'>
                                                            <div onClick={this.scrollToTop} className='back_message' >
                                                                <img src={back} alt="img" />
                                                            </div>
                                                            <div className='messageRight_subHAvatar'>
                                                                <img src={this.state.chats_user_image} alt="img" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div onClick={this.state.chats_userstatus === 1 ? () => this.handleProfileclick(this.state.chats_user_id) : '' } style={{cursor: 'pointer'}}>
                                                        <h4>{this.state.chats_user_name}</h4>
                                                        <p>{this.state.online_status}</p>
                                                    </div>
                                                    <select
                                                        className="select-language"
                                                        value={JSON.parse(localStorage.getItem('chatTransLang'))===""?"none":JSON.parse(localStorage.getItem('chatTransLang'))}
                                                        onChange={e => this.changeHandler(e.target.value)}
                                                        >
                                                        <option key="none" value="none"> None </option>
                                                        {languageCodes.map(lang => (
                                                            <option key={lang.language} value={lang.language}>
                                                            {lang.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <Dropdown className='mesagetabRight_headerdropdown'>
                                                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                                                        <img src={more} alt="img" />
                                                    </Dropdown.Toggle>
                                                    {this.state.chats_userstatus !== 2 && this.state.chats_userstatus !== 3 
                                                    ? (<Dropdown.Menu>
                                                        <Dropdown.Item onClick={() => this.onBlock(this.state.chats_user_id)} value={this.state.chats_user_id}>{t(this.state.blocked_by_me)}</Dropdown.Item>
                                                        <Dropdown.Item onClick={() => this.onUnfriend(this.state.chats_user_id)} value={this.state.chats_user_id}><Trans i18nKey="Unfriend">Unfriend</Trans></Dropdown.Item>
                                                        <Dropdown.Item onClick={() => this.onClearchat(this.state.chat_id)} value=""><Trans i18nKey="Clear Chat">Clear Chat</Trans></Dropdown.Item>
                                                    </Dropdown.Menu>) 
                                                    : (<Dropdown.Menu>
                                                        <Dropdown.Item onClick={() => this.onClearchat(this.state.chat_id)} value=""><Trans i18nKey="Clear Chat">Clear Chat</Trans></Dropdown.Item>
                                                    </Dropdown.Menu>)}
                                                </Dropdown>
                                            </div>
                                            <div className='message_rightsidecontent'>
                                                <div className='messagetagR_whole'>
                                                    <Row>
                                                        {this.state.chats.length > 0 ? (
                                                            this.state.chats.map((chat, index) => (
                                                                <Col md={12} key={`chat-${index}`}>
                                                                    {chat.sender_id === JSON.parse(localStorage.getItem('session_userid')) ? (
                                                                        <div className='messageTabR_content_floatR col-md-6'>
                                                                            <div className='messageTabR_content col-md-12 feed_des'>
                                                                                {chat.type === 'text' ? (
                                                                                    <h4>{chat.message}</h4>
                                                                                ) : chat.type === 'image' ? (
                                                                                    <a href={chat.upload_image} target="_blank"><img src={chat.upload_image} /></a>
                                                                                ) : chat.type === 'missed' ? (
                                                                                    <h4>{chat.message}</h4>
                                                                                ) : chat.type === 'audio_msg' ? (
                                                                                    <h4>{chat.message}</h4>
                                                                                ) : chat.type === 'gif' ? (
                                                                                    <h4>{chat.message}</h4>
                                                                                ) : chat.type === 'feed' && chat.feeds.feed_type === 'image' ? (
                                                                                    <img src={chat.feeds.feed_content_images} alt="img" />
                                                                                ) : chat.type === 'feed' && chat.feeds.feed_type !== 'image' ? (
                                                                                    <>
                                                                                        <img src={this.state.chats_user_image} alt="img" />
                                                                                        <h4>{chat.feeds.feed_type}</h4>
                                                                                        <p>{chat.feeds.feed_content}</p>
                                                                                    </>
                                                                                ) : null}
                                                                                <div className='message_time_first'>
                                                                                    <p>{chat.date}</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <div className='messageTabR_content_floatL col-md-6'>
                                                                            <div className='messgeTabL_content col-md-12'>
                                                                                {chat.type === 'text' ? (
                                                                                    <>
                                                                                        <h4>{chat.message}</h4>                                                                                    
                                                                                        {
                                                                                        chat.sender_id === JSON.parse(localStorage.getItem('session_userid')) 
                                                                                        ? "" 
                                                                                        : 
                                                                                        <a href="#" style={{"display":(transLangCode==='0') ? "none":"block"}} onClick={this.translateChat.bind(this, chat.message,JSON.parse(localStorage.getItem('chatTransLang')),index)}>
                                                                                            <div className="translateImg">
                                                                                                <img src={require('../../assets/img/icons/translatesIcon.png')} alt="transIcon" />
                                                                                            </div>
                                                                                        </a>                                                                            
                                                                                        }
                                                                                    </>
                                                                                ) : chat.type === 'image' ? (
                                                                                    <img src={chat.upload_image} alt="img" />
                                                                                ) : chat.type === 'missed' ? (
                                                                                    <h4>{chat.message}</h4>
                                                                                ) : chat.type === 'audio_msg' ? (
                                                                                    <h4>{chat.message}</h4>
                                                                                ) : chat.type === 'gif' ? (
                                                                                    <h4>{chat.message}</h4>
                                                                                ) : chat.type === 'feed' && chat.feeds.feed_type === 'image' ? (
                                                                                    <img src={chat.feeds.feed_content_images} alt="img" />
                                                                                ) : chat.type === 'feed' && chat.feeds.feed_type !== 'image' ? (
                                                                                    <>
                                                                                        <img src={this.state.chats_user_image} alt="img" />
                                                                                        <h4>{chat.feeds.feed_type}</h4>
                                                                                        <p>{chat.feeds.feed_content}</p>
                                                                                    </>
                                                                                ) : null}
                                                                                <div className='message_time_second'>
                                                                                    <p>{chat.date}</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </Col>
                                                            ))
                                                        ) : (
                                                            <Col md={12}>
                                                                <h4><Trans i18nKey="No messages available.">No messages available.</Trans></h4>
                                                            </Col>
                                                        )}
                                                    </Row>
                                                </div>
                                                <div ref={this.messagesEndRef}></div>
                                            </div>
                                        </div>
                                        <div className={this.state.loading}>
                                            <span>Typing</span>
                                            <span class="blinking">.</span>
                                            <span class="blinking1">.</span>
                                            <span class="blinking2">.</span>
                                        </div>
                                        <div className="message_bottomsearch">
                                            {(this.state.delete_info && this.state.delete_info !== "") || (this.state.block_info && this.state.block_info !== "") ?
                                                <>
                                                    <Form.Control
                                                        value={this.state.delete_info ? this.state.delete_info : this.state.block_info}
                                                        placeholder={t("Type a message....")}
                                                        readOnly
                                                    />
                                                    <div className="message_search_right">
                                                        <img src={attach} alt="img" />
                                                        <Button disabled><Trans i18nKey="Send">Send</Trans></Button>
                                                    </div>
                                                </>
                                                :
                                                <>
                                                    <Form.Control
                                                        value={this.state.inputValue}
                                                        placeholder={t("Type a message....")}
                                                        onChange={this.handleChange}
                                                        onKeyUp={this.handleKeyUp}
                                                        id="messageinput"
                                                    />
                                                    <div className="message_search_right">
                                                        <img src={attach} alt="Attach" onClick={() => this.handleImageClick()} />
                                                        <input type="file" style={{ display: 'none' }} ref={this.fileInputRef}
                                                            onChange={this.handleFileChange} />
                                                        <Button onClick={() => this.handleSendClick(this.state.chat_id, this.state.chats_user_id)}><Trans i18nKey="Send">Send</Trans></Button>
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    </Tab.Pane>
                                </Tab.Content>
                            </div>
                        </div>
                    </Tab.Container>
                </div>
                
                <Modal isOpen={this.state.appofmodal} toggle={this.shutModal.bind(this, 'appofmodal')} className="modal_div joinplan_modal" >
                    <ModalHeader>
                        <p><Trans i18nKey="App of the day">App of the day</Trans></p>
                    </ModalHeader>
                    <ModalBody className="religion_modal paymentsuccess_modal">
                        <div className='appofcard'>
                            <Slider {...settings}>
                                {
                                    this.state.appof_image.map((image) => (
                                        <div>
                                            <div className='slider_img appof_slider'>
                                                <img src={image} alt="img" />
                                            </div>
                                        </div>
                                    ))
                                }
                            </Slider>
                        </div>
                        <div className='appofcontent'>
                            <h4>{this.state.appof_day['title']}</h4>
                            <p>{this.state.appof_day['description']}</p>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <a href={this.state.appof_day['view_url_web']} target="_blank" className='appof_a'><Button className='button_primary appof_button'><Trans i18nKey="Open">Open</Trans></Button></a>
                    </ModalFooter>
                </Modal>

            </div>
        );
    }
}

export default withTranslation("translations")(withRouter(Messgae));
